function number(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
}

function calculateTimeAccountTableTotals({
  showWorkedHoursOnly,
  plannedHours,
  workedHours,
  autoCorrection,
  manualCorrection,
  regularBaseRate,
  totalAmount,
  hoursByRubrik = {}
}) {
  const correctionHours = number(autoCorrection) + number(manualCorrection);
  const correctionAmount = correctionHours * number(regularBaseRate);
  const plannedAmount = Object.values(hoursByRubrik)
    .reduce((sum, data) => sum + number(data.plannedAmount), 0);

  if (showWorkedHoursOnly) {
    return {
      hours: number(workedHours) + correctionHours,
      amount: number(totalAmount) + correctionAmount,
      correctionHours,
      correctionAmount
    };
  }

  return {
    hours: number(plannedHours),
    amount: plannedAmount,
    correctionHours,
    correctionAmount
  };
}

module.exports = {
  calculateTimeAccountTableTotals
};
